
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function TrigeminalNeuralgia(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Trigeminal Neuralgia(tic douloureux) "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Trigeminal neuralgia is <b>sudden, severe facial pain.</b> It's often described  as a sharp shooting pain or like having an electric shock in the jaw, teeth
                                    or gums. It usually happens in short, unpredictable attacks that can last
                                    from a few seconds to about 2 minutes.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/TrigeminalNeuralgia(tic-douloureux)/1.png")} alt="TrigeminalNeuralgia(tic-douloureux)" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Episodes of severe, shooting or jabbing pain that may feel like an electric shock</p>

                                <p>Spontaneous attacks of pain or attacks triggered by things such as touching the face,
                                    chewing, speaking or brushing teeth</p>
                                <p>Bouts of pain lasting from a few seconds to several minutes</p>
                                <p>Episodes of several attacks lasting days, weeks, months or longer — some people have periods
                                    when they experience no pain</p>
                                <p>Constant aching, burning feeling that may occur before it evolves into the spasm-like pain of
                                    trigeminal neuralgia</p>
                                <p>Pain in areas supplied by the trigeminal nerve, including the cheek, jaw, teeth, gums, lips, or less
                                    often the eye and forehead</p>
                                <p>Pain affecting one side of the face at a time, though may rarely affect both sides of the face</p>
                                <p>Pain focused in one spot or spread in a wider pattern</p>
                                <p>Attacks that become more frequent and intense over time</p>

                                <a className="links" href="https://en.wikipedia.org/wiki/Trigeminal_neuralgia">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default TrigeminalNeuralgia;